<template>
  <div class="ui-empty">
    <div class="ui-empty__icon">
      <i :class="['pi', icon]" />
    </div>
    <div class="ui-empty__title">{{ title }}</div>
    <div v-if="description" class="ui-empty__desc">{{ description }}</div>
    <div v-if="$slots.action" class="ui-empty__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  icon: { type: String, default: "pi-inbox" },
  title: { type: String, required: true },
  description: { type: String, default: "" },
});
</script>

<style scoped>
.ui-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--space-7) var(--space-4);
  gap: var(--space-2);
}
.ui-empty__icon {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-lg);
  background: var(--fill-quaternary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--space-2);
}
.ui-empty__icon i {
  font-size: 1.5rem;
  color: var(--label-secondary);
}
.ui-empty__title {
  font-size: var(--text-title-3);
  font-weight: var(--weight-semibold);
  color: var(--label-primary);
}
.ui-empty__desc {
  font-size: var(--text-callout);
  color: var(--label-secondary);
  max-width: 320px;
}
.ui-empty__action {
  margin-top: var(--space-3);
}
</style>
